// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.telegram-steps {
  margin: 4px 0 22px 0;
  border-radius: 12px;
  border-left: 4px solid #229ED9;
  background-color: #f3f9fd;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.telegram-step {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px 18px;
  font-size: 0.93rem;
  color: #2d2d2d;
  line-height: 1.55;
}

.telegram-step + .telegram-step {
  border-top: 1px solid #dde7ed;
}

/* StepBadge is an inline SVG (see TelegramConnectModal.js). The circle and
   the digit live inside the SVG, so this rule only handles the SVG's outer
   box: keep it from shrinking, and nudge it 1px down so the badge's center
   sits in the cap-height band of the first text line. */
.telegram-step-num {
  flex-shrink: 0;
  display: block;
  width: 26px;
  height: 26px;
  margin-top: 1px;
}

.telegram-step-body {
  flex: 1 1;
  min-width: 0;
}

.telegram-step code {
  background-color: #ffffff;
  border: 1px solid #d8e3ea;
  border-radius: 5px;
  padding: 1px 6px;
  font-family: 'SFMono-Regular', Menlo, Consolas, 'Courier New', monospace;
  font-size: 0.84em;
  color: #1f6b91;
}

.telegram-step a {
  color: #229ED9;
  text-decoration: none;
  font-weight: 600;
}

.telegram-step a:hover {
  text-decoration: underline;
}

.telegram-token-field input {
  letter-spacing: 0.02em;
}

.telegram-error {
  margin-top: 14px;
  padding: 10px 12px;
  background-color: #fdecea;
  border-radius: 8px;
  border-left: 4px solid #e53935;
  color: #611a15;
  font-size: 0.9rem;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/components/TelegramConnectModal.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;wDAGwD;AACxD;EACE,cAAc;EACd,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,wEAAwE;EACxE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".telegram-steps {\r\n  margin: 4px 0 22px 0;\r\n  border-radius: 12px;\r\n  border-left: 4px solid #229ED9;\r\n  background-color: #f3f9fd;\r\n  overflow: hidden;\r\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\r\n}\r\n\r\n.telegram-step {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 14px;\r\n  padding: 14px 18px;\r\n  font-size: 0.93rem;\r\n  color: #2d2d2d;\r\n  line-height: 1.55;\r\n}\r\n\r\n.telegram-step + .telegram-step {\r\n  border-top: 1px solid #dde7ed;\r\n}\r\n\r\n/* StepBadge is an inline SVG (see TelegramConnectModal.js). The circle and\r\n   the digit live inside the SVG, so this rule only handles the SVG's outer\r\n   box: keep it from shrinking, and nudge it 1px down so the badge's center\r\n   sits in the cap-height band of the first text line. */\r\n.telegram-step-num {\r\n  flex-shrink: 0;\r\n  display: block;\r\n  width: 26px;\r\n  height: 26px;\r\n  margin-top: 1px;\r\n}\r\n\r\n.telegram-step-body {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.telegram-step code {\r\n  background-color: #ffffff;\r\n  border: 1px solid #d8e3ea;\r\n  border-radius: 5px;\r\n  padding: 1px 6px;\r\n  font-family: 'SFMono-Regular', Menlo, Consolas, 'Courier New', monospace;\r\n  font-size: 0.84em;\r\n  color: #1f6b91;\r\n}\r\n\r\n.telegram-step a {\r\n  color: #229ED9;\r\n  text-decoration: none;\r\n  font-weight: 600;\r\n}\r\n\r\n.telegram-step a:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.telegram-token-field input {\r\n  letter-spacing: 0.02em;\r\n}\r\n\r\n.telegram-error {\r\n  margin-top: 14px;\r\n  padding: 10px 12px;\r\n  background-color: #fdecea;\r\n  border-radius: 8px;\r\n  border-left: 4px solid #e53935;\r\n  color: #611a15;\r\n  font-size: 0.9rem;\r\n  line-height: 1.4;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
